export function mapCanvasThemeDefaults(styles: Record<string, string | number>): void {
  if (styles['color'] === 'var(--ion-text-color)' || styles['color'] === '#0f172a') {
    styles['color'] = 'var(--bw-canvas-text-color)';
  }

  if (styles['background-color'] === '#ffffff') {
    styles['background-color'] = 'var(--bw-canvas-surface-color)';
  } else if (
    styles['background-color'] === 'rgba(15, 23, 42, 0.03)'
    || styles['background-color'] === 'rgba(15, 23, 42, 0.04)'
    || styles['background-color'] === 'rgba(15, 23, 42, 0.06)'
    || styles['background-color'] === 'rgba(15, 23, 42, 0.08)'
  ) {
    styles['background-color'] = 'var(--bw-canvas-surface-muted-color)';
  }

  if (styles['border-color'] === 'rgba(15, 23, 42, 0.08)') {
    styles['border-color'] = 'var(--bw-canvas-border-color)';
  }

  if (
    styles['box-shadow'] === '0 1rem 2rem rgba(15, 23, 42, 0.06)'
    || styles['box-shadow'] === '0 1.25rem 2.8rem rgba(15, 23, 42, 0.2)'
    || styles['box-shadow'] === '0 1.5rem 3.5rem rgba(15, 23, 42, 0.08)'
  ) {
    styles['box-shadow'] = 'var(--bw-canvas-shadow)';
  }
}
